<template>
<div class="m-auto ml-0px mr-0px w-100">
<div v-if="fromDate&&toDate" class="row icon">
<div class="col-6 text-center">{{fromDate|formatDate}}</div> <span>{{' '}}</span>
         <div class="col-6 text-center">{{toDate|formatDate}}</div>
</div>
<div v-else class="row icon ">
<div class="col-6 text-center" >{{fromLabel}}</div> <span>{{' '}}</span>
         <div class="col-6 text-center" >{{toLabel}}</div>
</div>
</div>
        
</template>
<script>
export default {
     props: {
    fromDate: {
      type: Date|String,
      default: null
    },
    toDate: {
      type: Date|String,
      default: null
    },
    fromLabel: {
      type: String,
      default: ''
    },
    toLabel: {
      type:String,
      default: ''
    }
  },
}
</script>